import { compose } from 'redux'

import SignInView from './SignInView'
import withAuth from 'containers/auth.container'

export default compose(withAuth)(SignInView)
